import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {ODSService} from '../services/ods.service';
import * as backInter from 'app/auth/auth-data.model';
import * as XLSX from 'xlsx';
import Swal from 'sweetalert2';
import {MatPaginator} from '@angular/material/paginator';
interface Institutos {
  value: string;
  viewValue: string;
}
import { saveAs } from 'file-saver';
///IDIOMAS
import { lang_perfiles } from 'app/idiomas/i18n/perfiles/perfiles.lang';
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
export interface Institute {
  numInstituto: number;
  regionInstituto: string;
}

@Component({
  selector: 'app-consultar-en',
  templateUrl: './consultar-en.component.html',
  styleUrls: ['./consultar-en.component.scss']
})
export class ConsultarEnComponent implements OnInit {
    @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  version3:boolean=true;
  cargando=false;
  cargando2=0;
  descargado=false;
  datosTabla:backInter.consultarEncuesta;
  institutos: Institutos[] = [
    {value: '1', viewValue: 'México'},
    {value: '2', viewValue: 'Centroamérica y El Caribe'},
    {value: '3', viewValue: 'China y Hong Kong'},
    {value: '4', viewValue: 'Filipinas'},
    {value: '5', viewValue: 'Singapur'},
    {value: '7', viewValue: 'Turquia'}
  ];
  skip:number;
  search='';
  institutoId:number;
  numeroUsuMostrarInicio:number;
  numeroUsuMostrarFinal:number;
  pagInicial:number;
  pagFinal:number;
  EncuestasMostrar=false;

  resulBus:any;
  resulMaster:any;
  busquedaTrue:boolean=false;// variable que habilita el filtro de empresa y tipo de empresa
  inputStart:boolean=false;
  exportToExcel(tableId: string, name?: string) {
    let timeSpan = new Date();
    let prefix = name || "Resultados exportados";
    let fileName = `${prefix}-${timeSpan}`;
    let targetTableElm = document.getElementById(tableId);
    if(targetTableElm!=null){
      let wb = XLSX.utils.table_to_book(targetTableElm, <XLSX.Table2SheetOpts>{ sheet: prefix });
      XLSX.writeFile(wb, `${fileName}.xlsx`);
      this.descargado=true;
    }
    else{
      this.descargado=false;
    }
  }


  export2Table(){
    this.exportToExcel("TablaResultadosEncuestas2");
  }

  displayed5Columns: string[] = [];
  dataSource2: MatTableDataSource<any>;
  //dataSource = new MatTableDataSource();

  anosSelect:any[]=[
    {ano:'2020'},
    {ano:'2021'},
    {ano:'2022'},
  ]
encuestaConsul(ano:any){
  console.log('ano',ano);
this.cargando2=1;
this.displayed5Columns=[];
this.inputStart=true;
    this.getMasterFile(ano);
}
  //institutoId=1;



  apply2Filter(filterValue: string) {
    this.dataSource2.filter = filterValue.trim().toLowerCase();
  }


  constructor(
    private _odsService: ODSService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService,
    private _fuseSidebarService: FuseSidebarService,
  ) {
    lang_perfiles.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });

  }

  ngOnInit() {
    this._fuseSidebarService.getSidebar('navbar').fold();
    this.getInstituteArray();

  }
  institutes:any;
  public getInstituteArray() {
    this._odsService.getInstituteArray()
    .subscribe(response => {

      let result: Institute[] = response['Institutos'];
      result.sort( (a,b) => { if(a.numInstituto > b.numInstituto){ return 1; } else{ return -1; } });
      this.institutes = result;
      console.log(result);



    }, error => {
      console.log("error", error);
    })
  }
  getMasterFile(ano) {
    // this.version2=true;
    this._odsService.getMasterFileService(ano).subscribe((response:any) => {
      console.log('getMasterFileService',response);
      this.resulMaster=response.data;
      this.cargando2=2;
      this.dataSource2 = new MatTableDataSource(this.resulMaster);
let datosPrincipal=this.dataSource2.data[0];
console.log('datosPrincipal',datosPrincipal);

      console.log('Object.keys(an_obj)',Object.keys(datosPrincipal));
      let arreglo: any[]=Object.keys(datosPrincipal);
arreglo.forEach(nombre => {
  this.displayed5Columns.push(nombre);
});
      // this.dataSource2.data[0].forEach( info => {
        // this.displayed5Columns.push(info);
      // });
      console.log('displayed5Columns',this.displayed5Columns);
      var scrollElem= document.querySelector('#scroolPrueba');
       scrollElem.scrollIntoView();
      setTimeout(() => this.dataSource2.paginator = this.paginator);
    }, error => {
      console.log("error", error);
    })
  }



  modalSucces(){
    let modalSucces = 'CONSULTARENCUESTA.MODAL_SUCCES';
    let modalWarning = 'CONSULTARENCUESTA.MODAL_WARNING';
    let rspSi = 'MODALES.ACCIONES.aceptar';
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    this.translateSrv.get(modalSucces).subscribe((res: string) => { modalSucces = res; });
    this.translateSrv.get(modalWarning).subscribe((res: string) => { modalWarning = res; });
    if(this.descargado==true){
      Swal.fire({
        title: modalSucces,
        icon: 'success',
        confirmButtonText: rspSi,
        confirmButtonColor: '#e40601'
      });
    }
    else{
      Swal.fire({
        title: modalWarning,
        icon: 'warning',
        confirmButtonText: rspSi,
        confirmButtonColor: '#e40601'
      });
    }
  }


  exportTable2(){
    // Swal.showLoading()
    var wb = XLSX.utils.book_new();
    wb.Props = {
      // Title: this.translateSrv.instant("COLABORADORES.EXCEL.TITUARCHIVO"),
      Title: 'Encuestas',
      Subject: 'CULTURAL GO',
      Author: 'ITBM',
      CreatedDate: new Date()
    };
    wb.SheetNames.push('hoja');
    var ws_data = [];
    let nombresColumnas:string[] = [];
    // backInter.CLAVES_COLUMNASCONSULENCUES.forEach( (nombre) => {
    //   switch(nombre){
    //     case 'Survey Token':nombresColumnas.push(this.translateSrv.instant('CONSULTARENCUESTA.CATALOGOSNAMETH.TH_SUR_TOK')); break;
    //     case 'Nombre de la empresa':nombresColumnas.push(this.translateSrv.instant('CONSULTARENCUESTA.CATALOGOSNAMETH.TH_NAM_EMP')); break;
    //     case 'NOMBRE DE PUBLICACION PARA LISTA':nombresColumnas.push(this.translateSrv.instant('CONSULTARENCUESTA.CATALOGOSNAMETH.TH_NAM_EMP_PUB')); break;
    //     case 'País de la Empresa':nombresColumnas.push(this.translateSrv.instant('CONSULTARENCUESTA.CATALOGOSNAMETH.TH_PA_EMP')); break;
    //     case 'Certificate Date':nombresColumnas.push(this.translateSrv.instant('CONSULTARENCUESTA.CATALOGOSNAMETH.TH_CER_DAT')); break;
    //     case 'Sector':nombresColumnas.push(this.translateSrv.instant('CONSULTARENCUESTA.CATALOGOSNAMETH.TH_SEC')); break;
    //     case 'Tipo Encuesta':nombresColumnas.push(this.translateSrv.instant('CONSULTARENCUESTA.CATALOGOSNAMETH.TH_TI_ENC')); break;
    //     case 'Survey Start':nombresColumnas.push(this.translateSrv.instant('CONSULTARENCUESTA.CATALOGOSNAMETH.TH_SUR_STA')); break;
    //     case 'Survey End':nombresColumnas.push(this.translateSrv.instant('CONSULTARENCUESTA.CATALOGOSNAMETH.TH_SUR_EN')); break;
    //     case 'ID Acount':nombresColumnas.push(this.translateSrv.instant('CONSULTARENCUESTA.CATALOGOSNAMETH.TH_ID_ACON')); break;
    //     case 'ID Oportunity':nombresColumnas.push(this.translateSrv.instant('CONSULTARENCUESTA.CATALOGOSNAMETH.TH_ID_OPOR')); break;
    //     case 'Año Ranking':nombresColumnas.push(this.translateSrv.instant('CONSULTARENCUESTA.CATALOGOSNAMETH.TH_ANO_RA')); break;
    //     case 'COMPAÑERISMO':nombresColumnas.push(this.translateSrv.instant('CONSULTARENCUESTA.CATALOGOSNAMETH.TH_COMPA')); break;
    //     case 'CREDIBILIDAD':nombresColumnas.push(this.translateSrv.instant('CONSULTARENCUESTA.CATALOGOSNAMETH.TH_CRED')); break;
    //     case 'Categoría Ranking':nombresColumnas.push(this.translateSrv.instant('CONSULTARENCUESTA.CATALOGOSNAMETH.TH_CATE_TAN')); break;
    //     case 'Confianza ': nombresColumnas.push(this.translateSrv.instant('CONSULTARENCUESTA.CATALOGOSNAMETH.TH_CONFI')); break;
    //     case 'Es Multinacional?':nombresColumnas.push(this.translateSrv.instant('CONSULTARENCUESTA.CATALOGOSNAMETH.TH_ES_MULT')); break;
    //     case 'GRUPO MULTINACIONAL AL QUE PERTENECE':nombresColumnas.push(this.translateSrv.instant('CONSULTARENCUESTA.CATALOGOSNAMETH.TH_GR_MUL_PER')); break;
    //     case 'Gestalt':nombresColumnas.push(this.translateSrv.instant('CONSULTARENCUESTA.CATALOGOSNAMETH.TH_GEST')); break;
    //     case 'IMPARCIALIDAD':nombresColumnas.push(this.translateSrv.instant('CONSULTARENCUESTA.CATALOGOSNAMETH.TH_IMPA')); break;
    //     case 'Innovación por Todos ':nombresColumnas.push(this.translateSrv.instant('CONSULTARENCUESTA.CATALOGOSNAMETH.TH_INN_TOD')); break;
    //     case 'Liderazgo Efectivo ':nombresColumnas.push(this.translateSrv.instant('CONSULTARENCUESTA.CATALOGOSNAMETH.TH_LID_EFE')); break;
    //     case 'Liderazgo en Movimiento ':nombresColumnas.push(this.translateSrv.instant('CONSULTARENCUESTA.CATALOGOSNAMETH.TH_LID_MOV')); break;
    //     case 'Maximizar CAST(Potencial Humano ':nombresColumnas.push(this.translateSrv.instant('CONSULTARENCUESTA.CATALOGOSNAMETH.TH_MAX_CAS')); break;
    //     case 'ORGULLO':nombresColumnas.push(this.translateSrv.instant('CONSULTARENCUESTA.CATALOGOSNAMETH.TH_ORG')); break;
    //     case 'PAIS (LEAD AFFILIATE)':nombresColumnas.push(this.translateSrv.instant('CONSULTARENCUESTA.CATALOGOSNAMETH.TH_PA_LEAFF')); break;
    //     case 'PROMEDIO AREA':nombresColumnas.push(this.translateSrv.instant('CONSULTARENCUESTA.CATALOGOSNAMETH.TH_PR_ARE')); break;
    //     case 'PROMEDIO EMPRESA':nombresColumnas.push(this.translateSrv.instant('CONSULTARENCUESTA.CATALOGOSNAMETH.TH_PR_EMP')); break;
    //     case 'PROMEDIO TI':nombresColumnas.push(this.translateSrv.instant('CONSULTARENCUESTA.CATALOGOSNAMETH.TH_PR_TI')); break;
    //     case 'REGIÓN':nombresColumnas.push(this.translateSrv.instant('CONSULTARENCUESTA.CATALOGOSNAMETH.TH_REG')); break;
    //     case 'RESPETO':nombresColumnas.push(this.translateSrv.instant('CONSULTARENCUESTA.CATALOGOSNAMETH.TH_RES')); break;
    //     case 'Propietario Cuenta':nombresColumnas.push(this.translateSrv.instant('CONSULTARENCUESTA.CATALOGOSNAMETH.TH_PRO_CUE')); break;
    //     case 'Total CA (AVG)':nombresColumnas.push(this.translateSrv.instant('CONSULTARENCUESTA.CATALOGOSNAMETH.TH_TOT_CA_AVG')); break;
    //     case 'Total CA (SUMA)':nombresColumnas.push(this.translateSrv.instant('CONSULTARENCUESTA.CATALOGOSNAMETH.TH_TOT_CA_SU')); break;
    //     case 'Valores':nombresColumnas.push(this.translateSrv.instant('CONSULTARENCUESTA.CATALOGOSNAMETH.TH_VAL')); break;
    //     case '¿Cuál es tu nivel de confianza en las capacidades de los directores de tu empresa? APLICO (SI / NO)':nombresColumnas.push(this.translateSrv.instant('CONSULTARENCUESTA.CATALOGOSNAMETH.TH_NIV_CONF')); break;
    //     case 'En los últimos 12 meses, ¿cuántas oportunidades has tenido para desarrollar, innovar o crear nuevas o mejores formas de':nombresColumnas.push(this.translateSrv.instant('CONSULTARENCUESTA.CATALOGOSNAMETH.TH_EN_ULT_12')); break;
    //     case ' # RESPUESTAS ESTUDIOS':nombresColumnas.push(this.translateSrv.instant('CONSULTARENCUESTA.CATALOGOSNAMETH.TH_#_RES_EST')); break;
    //     case ' Cargo o función homologado US APLICO (SI / NO)':nombresColumnas.push(this.translateSrv.instant('CONSULTARENCUESTA.CATALOGOSNAMETH.TH_CAR_HOMO')); break;
    //     case ' Edad US APLICO (SI / NO)':nombresColumnas.push(this.translateSrv.instant('CONSULTARENCUESTA.CATALOGOSNAMETH.TH_ED_US_AP')); break;
    //     case ' Generación US APLICO (SI / NO)':nombresColumnas.push(this.translateSrv.instant('CONSULTARENCUESTA.CATALOGOSNAMETH.TH_GEN_US_AP')); break;
    //     case ' Género APLICO (SI / NO)':nombresColumnas.push(this.translateSrv.instant('CONSULTARENCUESTA.CATALOGOSNAMETH.TH_GE_APL')); break;
    //     case ' Situación laboral US APLICO (SI / NO)':nombresColumnas.push(this.translateSrv.instant('CONSULTARENCUESTA.CATALOGOSNAMETH.TH_SI_AP')); break;
    //     case '# HC':nombresColumnas.push(this.translateSrv.instant('CONSULTARENCUESTA.CATALOGOSNAMETH.TH_HC')); break;
    //   }
    // });
    this.displayed5Columns.forEach( (nombre) => {
      nombresColumnas.push(nombre);
    });
    console.log("Colaboradores")
    ws_data.push(nombresColumnas);
    this.dataSource2.data.forEach( (info) => {
      let datosEncuestas:any[] = [];
      // backInter.CLAVES_COLUMNASCONSULENCUES.forEach( (nombre) => {
      //   switch(nombre){
      //     case ' # RESPUESTAS ESTUDIOS': datosEncuestas.push(info[' # RESPUESTAS ESTUDIOS']); break;
      //     case ' Antigüedad US APLICO (SI / NO)': datosEncuestas.push(info[' Antigüedad US APLICO (SI / NO)']); break;
      //     case ' Cargo o función homologado US APLICO (SI / NO)': datosEncuestas.push(info[' Cargo o función homologado US APLICO (SI / NO)']); break;
      //     case ' Edad US APLICO (SI / NO)': datosEncuestas.push(info[' Edad US APLICO (SI / NO)']); break;
      //     case ' Generación US APLICO (SI / NO)': datosEncuestas.push(info[' Generación US APLICO (SI / NO)']); break;
      //     case ' Género APLICO (SI / NO)': datosEncuestas.push(info[' Género APLICO (SI / NO)']); break;
      //     case ' Situación laboral US APLICO (SI / NO)': datosEncuestas.push(info[' Situación laboral US APLICO (SI / NO)']); break;
      //     case '# HC': datosEncuestas.push(info['# HC']); break;
      //     case 'Año Ranking': datosEncuestas.push(info['Año Ranking']); break;
      //     case 'COMPAÑERISMO': datosEncuestas.push(info['COMPAÑERISMO']); break;
      //     case 'CREDIBILIDAD': datosEncuestas.push(info['CREDIBILIDAD']); break;
      //     case 'Categoría Ranking': datosEncuestas.push(info['Categoría Ranking']); break;
      //     case 'Certificate Date': datosEncuestas.push(info['Certificate Date']); break;
      //     case 'Confianza ': datosEncuestas.push(info['Confianza']); break;
      //     case 'En los últimos 12 meses, ¿cuántas oportunidades has tenido para desarrollar, innovar o crear nuevas o mejores formas de': datosEncuestas.push(info['En los últimos 12 meses, ¿cuántas oportunidades has tenido para desarrollar, innovar o crear nuevas o mejores formas de']); break;
      //     case 'Es Multinacional?':datosEncuestas.push(info['Es Multinacional?']); break;
      //     case 'GRUPO MULTINACIONAL AL QUE PERTENECE':datosEncuestas.push(info['GRUPO MULTINACIONAL AL QUE PERTENECE']); break;
      //     case 'Gestalt': datosEncuestas.push(info['Gestalt']); break;
      //     case 'ID Acount': datosEncuestas.push(info['ID Acount']); break;
      //     case 'ID Oportunity': datosEncuestas.push(info['ID Oportunity']); break;
      //     case 'IMPARCIALIDAD': datosEncuestas.push(info['IMPARCIALIDAD']); break;
      //     case 'Innovación por Todos ': datosEncuestas.push(info['Innovación por Todos ']); break;
      //     case 'Liderazgo Efectivo ': datosEncuestas.push(info['Liderazgo Efectivo ']); break;
      //     case 'Liderazgo en Movimiento ': datosEncuestas.push(info['Liderazgo en Movimiento ']); break;
      //     case 'Maximizar CAST(Potencial Humano ': datosEncuestas.push(info['Maximizar CAST(Potencial Humano ']); break;
      //     case 'NOMBRE DE PUBLICACION PARA LISTA': datosEncuestas.push(info['NOMBRE DE PUBLICACION PARA LISTA']); break;
      //     case 'Nombre de la empresa': datosEncuestas.push(info['Nombre de la empresa']); break;
      //     case 'ORGULLO': datosEncuestas.push(info['ORGULLO']); break;
      //     case 'PAIS (LEAD AFFILIATE)': datosEncuestas.push(info['PAIS (LEAD AFFILIATE)']); break;
      //     case 'PROMEDIO AREA': datosEncuestas.push(info['PROMEDIO AREA']); break;
      //     case 'PROMEDIO EMPRESA': datosEncuestas.push(info['PROMEDIO EMPRESA']); break;
      //     case 'PROMEDIO TI': datosEncuestas.push(info['PROMEDIO TI']); break;
      //     case 'País de la Empresa': datosEncuestas.push(info['País de la Empresa']); break;
      //     case 'Propietario Cuenta': datosEncuestas.push(info['Propietario Cuenta']); break;
      //     case 'REGIÓN': datosEncuestas.push(info['REGIÓN']); break;
      //     case'RESPETO': datosEncuestas.push(info['RESPETO']); break;
      //     case'Sector': datosEncuestas.push(info['Sector']); break;
      //     case'Survey End': datosEncuestas.push(info['Survey End']); break;
      //     case'Survey Start': datosEncuestas.push(info['Survey Start']); break;
      //     case'Survey Token': datosEncuestas.push(info['Survey Token']); break;
      //     case 'Tipo Encuesta': datosEncuestas.push(info['Tipo Encuesta']); break;
      //     case 'Total CA (AVG)': datosEncuestas.push(info['Total CA (AVG)']); break;
      //     case 'Total CA (SUMA)': datosEncuestas.push(info['Total CA (SUMA)']); break;
      //     case 'Valores': datosEncuestas.push(info['Valores']); break;
      //     case '¿Cuál es tu nivel de confianza en las capacidades de los directores de tu empresa? APLICO (SI / NO)': datosEncuestas.push(info['¿Cuál es tu nivel de confianza en las capacidades de los directores de tu empresa? APLICO (SI / NO)']); break;
      //   }
      // });
      this.displayed5Columns.forEach( (nombre) => {
        datosEncuestas.push(info[nombre]);

      });
      ws_data.push(datosEncuestas);
      // console.log(ws_data);
    });
    var ws = XLSX.utils.aoa_to_sheet(ws_data);
    wb.Sheets['hoja'] = ws;
    var wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});
    var buf = new ArrayBuffer(wbout.length); //convert s to arrayBuffer
    var view = new Uint8Array(buf);  //create uint8array as viewer
    for (var i=0; i<wbout.length; i++) view[i] = wbout.charCodeAt(i) & 0xFF; //convert to octet
    // saveAs(new Blob([buf],{type:"application/octet-stream"}), `${this.translateSrv.instant("COLABORADORES.EXCEL.TITUARCHIVO")}.xlsx`);
    saveAs(new Blob([buf],{type:"application/octet-stream"}), `${'Reporte consultar encuestas'}.xlsx`);
    // Swal.close();
  }
}
